import React from "react";
import { Enums } from "@shared";
import PropTypes from 'prop-types';

const TransactionBadge = ({ idTransactionStatus, isAutopay = null }) => {

    let statusBadge = null, autopayBadge = null;

    if (idTransactionStatus === Enums.TransactionStatus.declined || idTransactionStatus === Enums.TransactionStatus.rejected)
        statusBadge = (<span className="badge-failed">Failed</span>);

    if (isAutopay !== null && isAutopay === true)
        autopayBadge = (<span className="badge-autopay">Autopay</span>);

    return (
        <>
            {
                (statusBadge || autopayBadge) &&
                <div className="flex flex-row gap-x-2">
                    {autopayBadge}
                    {statusBadge}
                </div>
            }
        </>
    );
}

TransactionBadge.propTypes = {
    idTransactionStatus: PropTypes.number.isRequired,
    isAutopay: PropTypes.bool
};

export default TransactionBadge;